import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { afterItems, beforeItems } from '../../data/content';
export function BeforeAfter() {
  return <section className="w-full bg-[#FBF8F3] px-5 py-14 sm:px-6 sm:py-20" data-id="element-70" data-mp="26lutcc89j2bx">
      <div className="mx-auto max-w-4xl" data-id="element-71" data-mp="22krcbmehb094">
        <h2 className="text-center font-display text-[1.7rem] font-bold leading-[1.12] tracking-[-0.01em] text-[#0E3B42] sm:text-4xl" data-id="element-72" data-mp="22lsmlono7ips">
          Smetti di improvvisare.
          <br data-id="element-73" data-mp="2uc6xdc0e0ex8" />
          <em className="font-semibold italic text-[#17808D]" data-id="element-74" data-mp="2ubp2ojtdi8rf">
            Inizia a seguire un Percorso Clinico.
          </em>
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-center text-[15px] leading-relaxed text-[#3F5F64] sm:text-base" data-id="element-75" data-mp="2q8ip0r3xlfax">
          Migliaia di pagine di linee guida internazionali si trasformano in un
          unico sistema decisionale che puoi applicare già dalla tua prossima
          visita.
        </p>

        <div className="mt-9 grid gap-4 sm:mt-12 sm:grid-cols-2 sm:gap-5" data-id="element-76" data-mp="19usildpcaey4">
          <div className="rounded-2xl border border-[#0E3B42]/10 bg-white p-5 sm:p-6" data-id="element-77" data-mp="176npq1qgvj9n">
            <p className="text-[11px] font-extrabold uppercase tracking-[0.18em] text-[#B4442F]" data-id="element-78" data-mp="1c3e50mug6au0">
              Prima
            </p>
            <ul className="mt-4 space-y-3.5" data-id="element-79" data-mp="y4eef9ndjlv7">
              {beforeItems.map(item => <li key={item} className="flex gap-3" data-id="element-80" data-mp="131xv0g7joaqb">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-[#F6E4E0]" aria-hidden="true" data-id="element-81" data-mp="oecvsxdsivno">
                    <XIcon className="h-3 w-3 text-[#B4442F]" data-id="element-82" data-mp="fepz2ow0ae0y" />
                  </span>
                  <span className="text-[14.5px] leading-snug text-[#4A6B70]" data-id="element-83" data-mp="jfia9nofuszv">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>

          <div className="rounded-2xl border border-[#17808D]/25 bg-[#0E3B42] p-5 sm:p-6" data-id="element-84" data-mp="aetx0v6vcwo1">
            <p className="text-[11px] font-extrabold uppercase tracking-[0.18em] text-[#7FD0DA]" data-id="element-85" data-mp="2c40uemcojg40">
              Con il Percorso Clinico GLP-1
            </p>
            <ul className="mt-4 space-y-3.5" data-id="element-86" data-mp="27bzjp4v5txg3">
              {afterItems.map(item => <li key={item} className="flex gap-3" data-id="element-87" data-mp="23ch1iguq40gy">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-[#17808D]" aria-hidden="true" data-id="element-88" data-mp="1yd4d3ro7elc9">
                    <CheckIcon className="h-3 w-3 text-white" data-id="element-89" data-mp="2r1tbhixvkckb" />
                  </span>
                  <span className="text-[14.5px] font-medium leading-snug text-white" data-id="element-90" data-mp="2m2glipbpipdi">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>

        <CTAButton className="mt-10" label="Voglio il mio percorso clinico oggi" subline="Accesso immediato · €19 pagamento unico" data-id="element-91" data-mp="1anteafqez10r" />
      </div>
    </section>;
}